(
    function (skyward, $)
    {
        'use strict'; 

        var init = function (selector)
        {
            $(selector + ' .js-getTestDetails').on('change', triggerTestDetails);
            $(selector + ' .js-calculateIsPassingScore').on('change', function ()
            {
                var fieldPrefix = skyward.controls.getValue('#TableNameHidden');
                var scoreFieldName = skyward.controls.getValue('#ScoreFieldNameHidden');
                var isPassingScoreFieldName = skyward.controls.getValue('#IsPassingScoreFieldNameHidden');
                var scoreValue = skyward.controls.getValue('#' + fieldPrefix + '_' + scoreFieldName);
                var passingScoreValue = skyward.controls.getValue('#PassingScoreHidden');

                skyward.controls.setValue('#' + fieldPrefix + '_' + isPassingScoreFieldName, parseInt(scoreValue) >= parseInt(passingScoreValue));
            });

            if ($(selector).find("#TestControls").length)
            {
                $(selector).find("select.TestSelectClassname").on("change", function () { testControlChanged(); });
                $(selector).find("select.TestVersionSelectClassname").on("change", function () { testVersionControlChanged(); });
            }
        };

        var triggerTestDetails = function ()
        {
            var testVersionID = skyward.controls.getValue($('#StudentTestTestVersionID'));

            $.ajax
                ({
                    url: skyward.global.virtualDir + 'Assessment/StudentTest/TestDetailsWorkflow',
                    type: 'POST',
                    dataType: 'HTML',
                    data: { selectedTestVersion: testVersionID },
                    success: function (returnData)
                    {
                        var parseData = JSON.parse(returnData);
                        if (parseData.Success)
                        {
                            $('#TestDetailsDiv').html(parseData.ViewPartHtml);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad('#TestDetailsDiv');
                        }
                    }
                });
        };

        var testControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControl = $("select.TestVersionSelectClassname");
            var sectionID = skyward.controls.getValue($("#SectionID"));
            var jsonDict = JSON.parse(skyward.controls.getValue($("#TestDict")));

            if (testSelectControlValue in jsonDict)
            {
                var test = jsonDict[testSelectControlValue];

                var newSelectedTestVersionID = "";

                var versionKeys = Object.keys(test.TestVersions);
                var orderedVersionKeys = Object.keys(test.TestVersionsByDisplayOrder);

                if (versionKeys.length > 0 && orderedVersionKeys.length > 0)
                {
                    newSelectedTestVersionID = test.TestVersionsByDisplayOrder[orderedVersionKeys.length];

                    testVersionSelectControl.empty();

                    for (var key in test.TestVersionsByDisplayOrder)
                    {
                        var realKey = test.TestVersionsByDisplayOrder[key];
                        testVersionSelectControl.append($('<option></option>').attr("value", realKey).attr("classname", "option ").text(test.TestVersions[realKey]));
                    }
                    skyward.controls.setValue(testVersionSelectControl, newSelectedTestVersionID);

                    RebuildStudentTestBrowse(sectionID, testSelectControlValue, newSelectedTestVersionID);
                }
            }
        }

        var testVersionControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControlValue = skyward.controls.getValue($("select.TestVersionSelectClassname"));
            var sectionID = skyward.controls.getValue($("#SectionID"));

            RebuildStudentTestBrowse(sectionID, testSelectControlValue, testVersionSelectControlValue);
        }

        var RebuildStudentTestBrowse = function (sectionID, selectedTestID, selectedTestVersionID)
        {
            var dataParams =
            {
                sectionID: sectionID,
                selectedTestID: selectedTestID,
                selectedTestVersionID: selectedTestVersionID
            };

            $.ajax
                ({
                    url: skyward.global.virtualDir + "Assessment/StudentTestBySection/RebuildStudentTestBrowse",
                    type: "POST",
                    dataType: "JSON",
                    data: dataParams,
                    success: async function (returnData) {
                        var updateHTML = returnData.Success;
                        if (updateHTML === true)
                        {
                            const viewPartHTML = await skyward.global.processScriptHtml(returnData.ViewPartHTML);
                            $('#StudentTestsWrapperDiv').html(viewPartHTML);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad("#StudentTestsWrapperDiv");
                        }
                    }
                });
        }        

        function calculateReadingBeginningLevelTotal(context)
        {
            var readingBeginningLevelFields = ['ReadingBeginningLevelCategory1', 'ReadingBeginningLevelCategory2or3'];
            calculateReadingLevelTotal(context, 'ReadingBeginningLevelTotal', readingBeginningLevelFields);
        }

        function calculateReadingIntermediateLevelTotal(context)
        {
            var readingIntermediateLevelFields = ['ReadingIntermediateLevelCategory1', 'ReadingIntermediateLevelCategory2', 'ReadingIntermediateLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingIntermediateLevelTotal', readingIntermediateLevelFields);
        }

        function calculateReadingAdvancedLevelTotal(context)
        {
            var readingAdvancedLevelFields = ['ReadingAdvancedLevelCategory1', 'ReadingAdvancedLevelCategory2', 'ReadingAdvancedLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingAdvancedLevelTotal', readingAdvancedLevelFields);
        }

        function calculateReadingLevelTotal(context, totalField, readingLevelFields)
        {
            var readingLevelTotalID = context.find('#' + totalField);
            context.find('.js-Calculate' + totalField).on('change', function () { updateReadingLevelTotal(readingLevelTotalID, readingLevelFields); });
        }

        function updateReadingLevelTotal(totalField, fields)
        {
            var total = 0;

            fields.forEach(function (field)
            {
                var fieldValue = Number(skyward.controls.getValue($('#' + field)));
                if (fieldValue != null)
                {
                    total += fieldValue;
                }
            });

            skyward.controls.setValue(totalField, total);

            return total;
        }

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('studenttest',
        {
            'calculateReadingBeginningLevelTotal': calculateReadingBeginningLevelTotal,
            'calculateReadingIntermediateLevelTotal': calculateReadingIntermediateLevelTotal,
            'calculateReadingAdvancedLevelTotal': calculateReadingAdvancedLevelTotal
        });
    }(window.skyward = window.skyward || {}, window.jQuery)
)